import { REGEX } from "../../constants/regex";
import LoadingButton from "../common/LoadingButton";

export default function ResetPasswordForm({
    onSend,
    t,
    resetUserIdError,
    resetUserIdInvalid,
    resetEmailError,
    resetUserIdValue,
    resetEmailValue,
    onResetUserIdChange,
    onResetEmailChange,
    onResetUserIdBlur
}) {
    const showUserIdErr = resetUserIdError || resetUserIdInvalid;

    return (
        <div className="pwd-panel flex flex-column w-full gap-2">
            <div className="form-field">
                <label htmlFor="reset_userId" className="keduall-typography text-16-normal-400 text-default required">
                    {t.resetIdLabel}
                </label>
                <input
                    id="reset_userId"
                    type="text"
                    maxLength={100}
                    className={
                        `keduall-form form-input-default-filled-large w-full validate keduall-typography text-16-normal-400`
                        + (showUserIdErr ? ' invalid' : '')
                    }
                    value={resetUserIdValue}
                    onChange={(e) => onResetUserIdChange(e.target.value)}
                    onBlur={onResetUserIdBlur}
                />
                <div className="help">
                    {showUserIdErr && (
                        <small className="text-danger-txt keduall-typography text-14-normal-400">
                            {resetUserIdValue.trim() === '' ? (t.resetIdRequiredLabel || 'This field is required') : (t.resetIdInvalidLabel || 'Invalid ID')}
                        </small>
                    )}
                </div>
            </div>

            <div className="form-field mt-4">
                <label htmlFor="reset_email" className="keduall-typography text-16-normal-400 text-default required">
                    {t.resetEmailLabel}
                </label>
                <input
                    id="reset_email"
                    type="email"
                    maxLength={254}
                    className={
                        `keduall-form form-input-default-filled-large w-full validate keduall-typography text-16-normal-400`
                        + (resetEmailError ? ' invalid' : '')
                    }
                    value={resetEmailValue}
                    onChange={(e) => onResetEmailChange(e.target.value)}
                />
                <div className="help">
                    {resetEmailError && (
                        <small className="text-danger-txt keduall-typography text-14-normal-400">
                            {resetEmailValue.trim() === '' ? (t.resetEmailRequiredLabel || 'This field is required') : (t.findIdEmailFormatInvalidLabel || 'Invalid email format')}
                        </small>
                    )}
                </div>
            </div>

            <div className="flex gap-2 justify-center pt-4">
                <LoadingButton
                    onClick={onSend}
                    label={t.resetSendLinkButtonLabel}
                    className="keduall-buttons button-filled-default-large-primary flex-1 keduall-typography heading-h6-semibold-600 text-white-txt"
                    disabled={
                        resetUserIdInvalid
                        || !resetUserIdValue.trim()
                        || !resetEmailValue.trim()
                        || !REGEX.EMAIL.test(resetEmailValue)
                    }
                />
            </div>
        </div>
    );
}